import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";
import { InformationPopupComponent } from "./information-popup.component";

export class OrderRejectionMessageComponent implements IComponent {
    public id = '';

    private base: IChartContainer;

    constructor(base: IChartContainer) {
        this.base = base;
        this.subscribeChartDataService();
    }

    private subscribeChartDataService() {
        this.base.chartService.subscribe_OrderRejectionMessage((message: string) => {
            if (message) {
                this.show(message);
            }
        });
    }

    private show(message: string) {
        const comp = this.base.getComponentsByType(InformationPopupComponent)?.[0] as InformationPopupComponent;
        if (comp) {
            comp.show(`Order Rejected`, message, null, null, null);
        }
    }
}